import React from 'react';
import { motion } from 'framer-motion';
import { Palette, MousePointerClick, Zap, MessageCircle } from 'lucide-react';
const features = [{
  title: 'Diseño de Élite',
  description: 'Imagen de marca superior a tu competencia.',
  icon: Palette
}, {
  title: 'Botones de Acción',
  description: 'Reserva directa a tu WhatsApp en 1 toque.',
  icon: MousePointerClick
}, {
  title: 'Velocidad Rayo',
  description: 'Carga instantánea para clientes con prisa en Chicago.',
  icon: Zap
}];
export function WhyUsSection() {
  return <section className="py-24 md:py-32 bg-brand-black bg-grain" data-id="element-111">
      <div className="content-relative max-w-6xl mx-auto px-4" data-id="element-112">
        {/* Section Heading */}
        <motion.div className="text-center mb-20" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-113">
          <h2 className="text-3xl md:text-5xl font-bold font-heading mb-4" data-id="element-114">
            Tu Negocio, en las <span className="text-gradient-gold" data-id="element-115">Manos</span>{' '}
            del <span className="text-gradient-gold" data-id="element-116">Mundo.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-117">
          {/* Left Column: Cinematic High-Fidelity Phone Mockup */}
          <motion.div className="flex justify-center relative" initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-118">
            {/* Dramatic Gold Aura */}
            <div className="absolute w-[350px] h-[350px] rounded-full bg-brand-gold/8 blur-[100px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-119"></div>

            <div className="relative w-[280px] h-[580px] rounded-[3rem] border-[6px] border-[#2A2A2A] shadow-[0_0_80px_rgba(212,175,55,0.2),0_20px_60px_rgba(0,0,0,0.5)] overflow-hidden flex flex-col ring-1 ring-white/10" style={{
            transform: 'perspective(1000px) rotateY(-5deg) rotateX(2deg)'
          }} data-id="element-120">
              {/* Glass Reflection */}
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white/10 via-transparent to-transparent pointer-events-none z-20" data-id="element-121"></div>

              {/* Dynamic Island Notch */}
              <div className="absolute top-2 left-1/2 -translate-x-1/2 h-[26px] w-[100px] bg-black rounded-full z-30" data-id="element-122">
                <div className="w-2 h-2 rounded-full bg-brand-charcoal-light absolute right-4 top-1/2 -translate-y-1/2" data-id="element-123"></div>
              </div>

              {/* Screen Content (Simulated Website) */}
              <div className="flex-1 bg-brand-black relative z-10 flex flex-col overflow-hidden" data-id="element-124">
                {/* Top Nav */}
                <div className="flex items-center justify-between p-4 pt-10 relative z-20" data-id="element-125">
                  <div className="w-7 h-7 rounded-full bg-brand-gold/20 flex items-center justify-center border border-brand-gold/30" data-id="element-126">
                    <div className="w-3 h-3 rounded-full bg-brand-gold/60" data-id="element-127"></div>
                  </div>
                  <div className="flex flex-col gap-1.5" data-id="element-128">
                    <div className="w-4 h-0.5 bg-white/70 rounded-full" data-id="element-129"></div>
                    <div className="w-4 h-0.5 bg-white/70 rounded-full" data-id="element-130"></div>
                  </div>
                </div>

                {/* Hero Area */}
                <div className="absolute top-0 left-0 w-full h-72 bg-gradient-to-b from-brand-gold/25 via-brand-gold/10 to-transparent z-0" data-id="element-131"></div>
                <div className="absolute top-0 left-0 w-full h-40 bg-gradient-to-br from-white/5 to-transparent z-0" data-id="element-132"></div>

                <div className="px-4 pt-12 pb-6 relative z-10 text-center" data-id="element-133">
                  <div className="w-8 h-[1px] bg-brand-gold/50 mx-auto mb-3" data-id="element-134"></div>
                  <div className="flex items-center justify-center" data-id="element-135">
                    <h3 className="text-brand-gold font-heading text-base tracking-[0.3em] uppercase font-bold" data-id="element-136">
                      THE ELITE CUT
                    </h3>
                    <span className="text-white/30 mx-1" data-id="element-137">|</span>
                    <h3 className="text-brand-gold font-heading text-base tracking-[0.3em] uppercase font-bold" data-id="element-138">
                      CHICAGO
                    </h3>
                  </div>
                  <p className="text-white/50 text-[10px] tracking-widest uppercase mt-2" data-id="element-139">
                    Premium Barbershop Experience
                  </p>
                </div>

                {/* Service Cards */}
                <div className="px-4 py-4 space-y-2.5 flex-1 relative z-10" data-id="element-140">
                  <div className="rounded-lg bg-brand-charcoal/80 border border-white/5 p-3.5 flex justify-between items-center" data-id="element-141">
                    <span className="text-white text-xs font-medium" data-id="element-142">
                      Signature Fade
                    </span>
                    <span className="text-brand-gold text-xs font-bold" data-id="element-143">
                      $45
                    </span>
                  </div>
                  <div className="rounded-lg bg-brand-charcoal/80 border border-white/5 p-3.5 flex justify-between items-center" data-id="element-144">
                    <span className="text-white text-xs font-medium" data-id="element-145">
                      Royal Shave
                    </span>
                    <span className="text-brand-gold text-xs font-bold" data-id="element-146">
                      $35
                    </span>
                  </div>
                </div>

                {/* Bottom CTA */}
                <div className="p-4 mt-auto relative z-10" data-id="element-147">
                  <button className="w-full bg-gradient-gold text-brand-black font-bold rounded-full text-[11px] py-3 tracking-widest uppercase shadow-[0_0_20px_rgba(212,175,55,0.4)]" data-id="element-148">
                    BOOK NOW
                  </button>
                </div>

                {/* Floating WhatsApp Icon */}
                <div className="absolute bottom-16 right-3 z-20 w-8 h-8 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg" data-id="element-149">
                  <MessageCircle className="w-4 h-4 text-white" data-id="element-150" />
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column: 3 Elegant Feature Cards */}
          <div className="flex flex-col justify-center space-y-6" data-id="element-151">
            {features.map((feature, index) => <motion.div key={feature.title} className="bg-brand-charcoal/50 rounded-2xl p-6 border border-white/5 hover:border-brand-gold/20 transition-colors duration-300" initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} data-id="element-152">
                <div className="w-12 h-12 rounded-xl bg-brand-gold/10 flex items-center justify-center mb-4" data-id="element-153">
                  <feature.icon className="w-6 h-6 text-brand-gold" data-id="element-154" />
                </div>
                <h3 className="font-heading font-bold text-lg text-white mb-2" data-id="element-155">
                  {feature.title}
                </h3>
                <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-156">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}